<div class="mt-3 text-sm p-2 surface-0">
  <div class="surface-0">
    <!-- Header -->
    <div
      class="py-2 px-3 border-bottom-1 border-300 flex align-items-center justify-content-between"
    >
      <strong>{{ 'SUBSCRIPTIONS.PAYMENT-TIMELINE' | translate }}</strong>
      <p-button
        (click)="ShowTimelineData()"
        styleClass="p-button-outlined text-xs"
        [label]="(canDoMidCycleDiscount ? 'SUBSCRIPTIONS.PAYMENT_TIMELINE.VIEW_FULL_TIMELINE' : 'SUBSCRIPTIONS.PAYMENT_TIMELINE.VIEW_FULL_TIMELINE_NO_DISCOUNT') | translate"
        icon="fa fa-timeline"
      />
    </div>
    <!-- Header -->
    <!-- Content -->
    <div class="pl-5 pr-1 pt-1 pb-4 overflow-x-auto overflow-y-hidden">
      <p-timeline
        [value]="(filtetredTimelineData$ | async) ?? []"
        layout="horizontal"
        styleClass="mt-2 md:ml-4 mb-0 white-space-nowrap payment-timeline-horizontal"
      >
        <ng-template pTemplate="marker" let-timeline>
          @if (isAfterSubscriptionEndDate(timeline)) {
            <span
              class="custom-marker h-2rem w-full max-w-2rem border-circle bg-gray-200 border-2 border-gray-300 flex align-items-center justify-content-center opacity-70"
              [pTooltip]="'SUBSCRIPTIONS.PAYMENT_TIMELINE.CANCELLED_MSG' | translate"
              tooltipStyleClass="text-xs"
              aria-label="cancelled-timeline-marker"
              data-testid="cancelled-timeline-marker"
            >
              <i class="fa fa-ban text-gray-500 text-xs" aria-hidden="true"></i>
            </span>
          } @else {
          @if (isBillingStoppedOccurance(timeline)) {
            <span
              class="custom-marker h-2rem w-full max-w-2rem border-circle p-button p-button-danger p-0 flex align-items-center justify-content-center"
            >
              <i
                [pTooltip]="getTooltipMessage(timeline)"
                tooltipStyleClass="text-xs"
                aria-label="billing-stopped-marker"
                class="fa fa-exclamation-triangle text-white"
              ></i>
            </span>
          }
          @if (
            !isBillingStoppedOccurance(timeline) &&
            timeline.payment_status &&
            isSuccessfulPayment(timeline)
          ) {
            <span [ngClass]="getTimelineMarkerClass(timeline)">
              @if (shouldShowIcon(timeline)) {
                @if (isFreezeOccurance(timeline)) {
                  <i
                    [pTooltip]="getTooltipMessage(timeline)"
                    tooltipStyleClass="text-xs"
                    aria-label="freeze-cycle-marker"
                    class="fa fa-snowflake text-white"
                  ></i>
                } @else if (isEnhancementOccurance(timeline)) {
                  <i
                    [pTooltip]="getTooltipMessage(timeline)"
                    tooltipStyleClass="text-xs"
                    aria-label="enhancement-cycle-marker"
                    data-testid="enhancement-cycle-marker"
                    class="fa fa-coins text-white"
                  ></i>
                } @else {
                  <i
                    [pTooltip]="getTooltipMessage(timeline)"
                    tooltipStyleClass="text-xs"
                    class="fa fa-exclamation-triangle text-white"
                  ></i>
                }
              }
            </span>
          }
          @if (
            !isBillingStoppedOccurance(timeline) &&
            timeline.payment_status &&
            isCreatedPayment(timeline)
          ) {
            <span [ngClass]="getTimelineMarkerClass(timeline)">
              @if (shouldShowIcon(timeline)) {
                @if (isFreezeOccurance(timeline)) {
                  <i
                    [pTooltip]="getTooltipMessage(timeline)"
                    tooltipStyleClass="text-xs"
                    aria-label="freeze-cycle-marker"
                    class="fa fa-snowflake text-white"
                  ></i>
                } @else if (isEnhancementOccurance(timeline)) {
                  <i
                    [pTooltip]="getTooltipMessage(timeline)"
                    tooltipStyleClass="text-xs"
                    aria-label="enhancement-cycle-marker"
                    data-testid="enhancement-cycle-marker"
                    class="fa fa-coins text-white"
                  ></i>
                } @else {
                  <i
                    [pTooltip]="getTooltipMessage(timeline)"
                    tooltipStyleClass="text-xs"
                    class="fa fa-exclamation-triangle text-white"
                  ></i>
                }
              }
            </span>
          }

          @if (
            !isBillingStoppedOccurance(timeline) &&
            (timeline.payment_status === paymentStatus.None ||
            timeline.payment_status.toString() ===
              paymentStatus[paymentStatus.None])
          ) {
            <span [ngClass]="getTimelineMarkerClass(timeline)">
              @if (shouldShowIcon(timeline)) {
                @if (isFreezeOccurance(timeline)) {
                  <i
                    [pTooltip]="getTooltipMessage(timeline)"
                    tooltipStyleClass="text-xs"
                    aria-label="freeze-cycle-marker"
                    class="fa fa-snowflake text-primary"
                  ></i>
                } @else if (isEnhancementOccurance(timeline)) {
                  <i
                    [pTooltip]="getTooltipMessage(timeline)"
                    tooltipStyleClass="text-xs"
                    aria-label="enhancement-cycle-marker"
                    data-testid="enhancement-cycle-marker"
                    class="fa fa-coins text-indigo-500"
                  ></i>
                } @else {
                  <i
                    [pTooltip]="getTooltipMessage(timeline)"
                    tooltipStyleClass="text-xs"
                    class="fa fa-exclamation-triangle"
                  ></i>
                }
              }
            </span>
          }
          @if (
            !isBillingStoppedOccurance(timeline) &&
            timeline.payment_status &&
            isfailedPayment(timeline)
          ) {
            <span
              class="custom-marker h-2rem w-full max-w-2rem border-circle p-button p-button-danger p-0 flex align-items-center justify-content-center"
            >
              <i
                [pTooltip]="'Failed due to : ' + timeline.failed_reason"
                tooltipStyleClass="text-xs"
                class="fa fa-exclamation-triangle text-white"
              >
              </i>
            </span>
          }
          }
        </ng-template>

        <ng-template pTemplate="content" let-timeline>
          <div
            class="text-left"
            [ngClass]="
              isAfterSubscriptionEndDate(timeline)
                ? 'w-8rem md:w-6rem min-h-3rem flex flex-column justify-content-start gap-1 -ml-2 pb-2'
                : 'w-7rem md:w-5rem'
            "
          >
            @if (isAfterSubscriptionEndDate(timeline)) {
              <span class="text-xs white-space-nowrap text-400 line-through">
                {{ timeline.invoice_amount_in_minor_currency | currencyformat }}
              </span>
              <p-tag
                severity="secondary"
                [value]="'SUBSCRIPTIONS.PAYMENT_TIMELINE.CANCELLED' | translate"
                styleClass="text-xxs py-0 px-2 surface-100 border-1 border-300 text-500 white-space-nowrap"
                tooltipStyleClass="text-xs"
                aria-label="cancelled-timeline-tag"
                data-testid="cancelled-timeline-tag"
              />
            } @else {
            @if (isBillingStoppedOccurance(timeline)) {
              <strong
                class="text-sm white-space-nowrap p-error block -mt-1 -ml-2"
              >
                {{
                  'SUBSCRIPTIONS.PAYMENT_TIMELINE.STOPPED_BILLING' | translate
                }}
              </strong>
            }
            @if (
              !isBillingStoppedOccurance(timeline) &&
              timeline.payment_status &&
              (timeline.payment_status === paymentStatus.None ||
                timeline.payment_status.toString() ===
                  paymentStatus[paymentStatus.None])
            ) {
              <div class="text-sm white-space-nowrap text-700 -mt-1 -ml-2">
                {{ timeline.invoice_amount_in_minor_currency | currencyformat }}
              </div>
            }

            @if (
              !isBillingStoppedOccurance(timeline) &&
              timeline.payment_status &&
              isSuccessfulPayment(timeline)
            ) {
              <strong class="text-sm white-space-nowrap block -mt-1 -ml-2">
                {{
                  timeline.occurance_invoice_id > 0
                    ? (timeline.payment_amount_in_minor_currency | currencyformat)
                    : (timeline.invoice_amount_in_minor_currency | currencyformat)
                }}
              </strong>
            }
            @if (
              !isBillingStoppedOccurance(timeline) && timeline.payment_status && isCreatedPayment(timeline)
            ) {
              <strong class="text-sm white-space-nowrap block -mt-1 -ml-2">
                {{ timeline.invoice_amount_in_minor_currency | currencyformat }}
              </strong>
            }
            @if (
              !isBillingStoppedOccurance(timeline) &&
              timeline.payment_status &&
              (timeline.payment_status === paymentStatus.Failed ||
                timeline.payment_status.toString() === paymentStatus[paymentStatus.Failed])
            ) {
              <strong
                class="text-sm white-space-nowrap p-error block -mt-1 -ml-3"
              >
                {{
                  timeline.occurance_invoice_id > 0
                    ? (timeline.payment_amount_in_minor_currency | currencyformat)
                    : (timeline.invoice_amount_in_minor_currency | currencyformat)
                }}
              </strong>
            }
            <div class="h-2rem -ml-2">
              @if (
                timeline.payment_status === paymentStatus.None ||
                timeline.payment_status.toString() ===
                  paymentStatus[paymentStatus.None] ||
                timeline.payment_status === paymentStatus.Initiated ||
                  timeline.payment_status.toString() ===
                    paymentStatus[paymentStatus.Initiated]
              ) {
                <div>
                  @if (
                    (timeline.occurance_type ===
                      recurringOccuranceType.Deposit ||
                      timeline.occurance_type.toString() ===
                        recurringOccuranceType[
                          recurringOccuranceType.Deposit
                        ]) &&
                    shouldDisplayDepositTag(timeline)
                  ) {
                    <p-tag
                      severity="success"
                      [value]="'DEPOSIT.DEPOSIT' | depositTranslate"
                      styleClass="text-xxs mb-1 block"
                      tooltipStyleClass="text-xs"
                    />
                  }
                  @if (
                    (timeline.occurance_type === recurringOccuranceType.Deposit || timeline.occurance_type.toString() === recurringOccuranceType[recurringOccuranceType.Deposit])
                     && shouldDisplayDepositTag(timeline)
                  ) {
                    <p-tag
                      [severity]="timeline.deposit_applied ? 'success' : 'secondary'"
                      [value]="
                        timeline.deposit_applied
                          ? ('DEPOSIT.DEPOSIT_STATUS_APPL' | depositTranslate)
                          : ('DEPOSIT.DEPOSIT_STATUS_SCHED' | depositTranslate)
                      "
                      styleClass="text-xxs block"
                      [ngClass]="{
                        'py-0 surface-0 border-1 border-400 text-600':
                          !timeline.deposit_applied,
                      }"
                      tooltipStyleClass="text-xs"
                    />
                  }
                  @if (shouldDisplayEnhancementTag(timeline)) {
                    <p-tag
                      severity="info"
                      [value]="'SUBSCRIPTIONS.PAYMENT_TIMELINE.ENHANCEMENT_TAG' | translate"
                      styleClass="text-xxs py-0 px-2 mb-1 inline-flex w-auto white-space-nowrap bg-indigo-50 text-indigo-700 border-1 border-indigo-200"
                      [pTooltip]="getTooltipMessage(timeline)"
                      tooltipStyleClass="text-xs"
                      aria-label="enhancement-timeline-tag"
                      data-testid="enhancement-timeline-tag"
                    />
                  }
                </div>
              }
              @if (
                timeline.payment_status !== paymentStatus.None && timeline.payment_status.toString() !== paymentStatus[paymentStatus.None]
              ) {
                <div>
                  @if (
                    (timeline.occurance_type ===
                      recurringOccuranceType.Deposit ||
                      timeline.occurance_type.toString() ===
                        recurringOccuranceType[
                          recurringOccuranceType.Deposit
                        ]) &&
                    shouldDisplayDepositTag(timeline)
                  ) {
                    <p-tag
                      severity="success"
                      [value]="'DEPOSIT.DEPOSIT' | depositTranslate"
                      styleClass="text-xxs py-0 mb-1 block"
                      [pTooltip]="getTooltipMessage(timeline)"
                      tooltipStyleClass="text-xs"
                    />
                  }
                  @if (
                    (timeline.occurance_type ===
                      recurringOccuranceType.Deposit ||
                      timeline.occurance_type.toString() ===
                        recurringOccuranceType[
                          recurringOccuranceType.Deposit
                        ]) &&
                    shouldDisplayDepositTag(timeline)
                  ) {
                    <p-tag
                      [severity]="timeline.deposit_applied ? 'success' : ''"
                      [value]="
                        timeline.deposit_applied
                          ? ('DEPOSIT.DEPOSIT_STATUS_APPL' | depositTranslate)
                          : ('DEPOSIT.DEPOSIT_STATUS_SCHED' | depositTranslate)
                      "
                      styleClass="text-xxs py-0 surface-0 border-1 border-400 text-600 block"
                      tooltipStyleClass="text-xs"
                    />
                  }
                  @if (shouldDisplayEnhancementTag(timeline)) {
                    <p-tag
                      severity="info"
                      [value]="'SUBSCRIPTIONS.PAYMENT_TIMELINE.ENHANCEMENT_TAG' | translate"
                      styleClass="text-xxs py-0 px-2 mb-1 inline-flex w-auto white-space-nowrap bg-indigo-50 text-indigo-700 border-1 border-indigo-200"
                      [pTooltip]="getTooltipMessage(timeline)"
                      tooltipStyleClass="text-xs"
                      aria-label="enhancement-timeline-tag"
                      data-testid="enhancement-timeline-tag"
                    />
                  }
                </div>
              }
              @if (
                timeline.payment_status && isCreatedPaymentWithInvoice(timeline)
              ) {
                <div>
                  <p-tag
                    severity="info"
                    [value]="'SUBSCRIPTIONS.PAYMENT_TIMELINE.INPROGRESS' | translate"
                    styleClass="text-xxs py-0"
                    tooltipStyleClass="text-xs"
                  />
                </div>
              }
              @if (isFailedPaymentWithRecurring(timeline)) {
                <span
                  (click)="callRetryPayment(timeline)"
                  class="p-error text-xs cursor-pointer -ml-5 flex align-items-center"
                  ><i
                    class="text-xs mr-1"
                    [ngClass]="isbuttonclicked ? 'fa fa-spinner' : 'fa fa-rotate-right'"
                  ></i
                  ><span class="underline">{{'DEPOSIT.RETRY_PAYMENT' | depositTranslate }}</span></span
                >
              }
            </div>
            }
          </div>
        </ng-template>
        <ng-template pTemplate="opposite" let-timeline let-i="index">
          <div
            class="text-left"
            [ngClass]="
              isAfterSubscriptionEndDate(timeline)
                ? 'w-8rem md:w-6rem pb-2'
                : 'w-7rem md:w-5rem'
            "
          >
            @if (
              timeline ===
                filtetredTimelineData$.value[
                  filtetredTimelineData$.value.length - 1
                ] &&
              (subscription().subscription_category === 'PayAsYouGo' || subscription().subscription_category === '1')
            ) {
              <span
                class="block text-xxs md:text-xs white-space-nowrap text-600 -mt-2 text-left"
              >
                <i class="fa-solid fa-infinity text-primary text-2xl"></i>
              </span>
            } @else {
              <span
                class="block text-xxs md:text-xs white-space-nowrap text-left"
                [ngClass]="{
                  'text-400 line-through -mt-1 -ml-2': isAfterSubscriptionEndDate(timeline),
                  '-mt-2 -ml-3': !isAfterSubscriptionEndDate(timeline),
                }"
              >
                {{ timeline.occurance_start_date | datetimeformat: 'ukformat' }}
              </span>
            }
          </div>
        </ng-template>
      </p-timeline>
    </div>
    <!-- Content -->
  </div>
</div>

<!-- Payment Timeline Modal  -->
<p-dialog
  [visible]="paymentTimelineModal"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '800px' }"
  styleClass="no-header-modal"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Header -->
    <div
      class="surface-0 sticky left-0 bottom-0 w-full z-1 border-bottom-1 border-300 p-3 flex align-items-center justify-content-between"
    >
      <h2 class="mb-0 text-sm line-height-1">
        {{ 'SUBSCRIPTIONS.PAYMENT_TIMELINE.HEADER' | translate }}
      </h2>
      <div
        class="fa fa-times text-xl text-600 cursor-pointer"
        (click)="paymentTimelineModal = false"
      ></div>
    </div>
    <!-- Header -->
    <!-- Content -->
    <app-data-grid
      [columnData]="timelineData$"
      [columns]="timelineDataTablecolumns$"
      [selectable]="selecall"
      tableClasses="shadow-2 p-0 my-3"
      [headerClasses]="'surface-100 text-xs text-600'"
      [paginator]="false"
      [EmptyState]="emptyStateComponentForHistory$"
      (onAction)="onActionEvent($event)"
      [gridName]="'payment-timeline-list'"
    />
    <!-- Content -->
  </ng-template>
</p-dialog>
<!-- Payment Timeline Modal -->

<app-edit-payment-timeline-popup
  [visible]="editPaymentTimelineModal"
  [occurrence]="selectedTimeline"
  (closePopup)="closeEditPaymentTimelinePopup()"
  (saved)="onEditPaymentTimelineSaved()"
/>
